module.exports = __webpack_public_path__ + "img/highlight-shape.bdea7f76.svg";